import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { IDivider } from "../data/types";
import { useDividerStyle } from "../style";

export const Divider = ({ prefix }: IDivider) => {
  const classes = useDividerStyle();
  return (
    <Grid className={classes.container}>
      <Typography className={classes.title} variant="h6">
        {prefix}
      </Typography>
      <span className={classes.line}></span>
    </Grid>
  );
};
